<!-- src/components/Home.vue -->

<template>
  <div>
    <header-component />
    <aboutUsBanner-component />
    <footer-component />
  </div>
</template>

<script>
import headerComponent from '../header/headerComponent.vue';
import aboutUsBannerComponent from '../aboutUs/aboutUsBannerComponent.vue';
import footerComponent from '../footer/footerComponent.vue';

export default {
  name: 'homeComponent',
  components: {
    headerComponent,
    aboutUsBannerComponent,
    footerComponent,
  },
};
</script>
